import { render, staticRenderFns } from "./table13.vue?vue&type=template&id=51142d26&scoped=true&"
import script from "./table13.vue?vue&type=script&lang=js&"
export * from "./table13.vue?vue&type=script&lang=js&"
import style0 from "./table13.vue?vue&type=style&index=0&id=51142d26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51142d26",
  null
  
)

export default component.exports